import React from 'react'
import {Route, Switch} from 'react-router-dom'
import Home from './components/home'
import FuturesMain from './components/futures/main'
import FuturesFeed from './components/futures/feed'
import PricingChart from './components/futures/pricingChart'
import BackgrounderList from './components/breakeven/backgrounderList'
import BackgrounderCalculator from './components/breakeven/backgrounderCalculator'
import FinishingList from './components/breakeven/finishingList'
import FinishingCalculator from './components/breakeven/finishingCalculator'
import PriceInsurance from './components/price/insurance'
import PriceProjectionsList from './components/price/projectionsList'
import ContactUs from './components/contact'
import Account from './components/account'
import Login from './components/login'
import Register from './components/register'
import ResetDefaults from './components/resetDefaults'
import {connect} from 'react-redux'
import {withRouter} from 'react-router'
import $ from 'jquery'
import {trim} from './helpers/textbuilders'
import PriceProjectionsCalculator from './components/price/projectionsCalculator'
import NotFound from './components/404notfound'
import ReactGA from 'react-ga'
import _ from 'lodash'

@withRouter
@connect((state) => {
  return state
})
export default class Main extends React.Component {
  constructor(props) {
    super(props)

    if (process.env.NODE_ENV === 'development') {
      ReactGA.initialize('UA-48102190-4')
    } else if (process.env.NODE_ENV === 'production') {
      ReactGA.initialize('UA-122171189-1')
    }

    // Update the body with specific classes and remove the previous class
    this.updateBodyClassForPath('', this.props.location.pathname)
    this.state = {prevPath: this.props.location.pathname}

    // Listen for changes to the url and update the body with specific classes
    this.props.history.listen((location, action) => {
      this.updateBodyClassForPath(this.state.prevPath, location.pathname)
      this.setState({prevPath: location.pathname})
    })
  }

  // Update the body with specific classes and remove the previous class
  updateBodyClassForPath = (lastPath, nextPath) => {
    if (lastPath !== '') {
      $('body').removeClass(trim('/', lastPath).replace(/\//g, '-'))
    }
    var className = trim('/', nextPath).replace(/\//g, '-')
    var pageViewName = className
    if (_.isNil(className) || _.isEmpty(className)) {
      className = 'home'
      pageViewName = 'home'
    } else if (_.startsWith(className, 'futures-pricingchart')) {
      className = 'futures-pricingchart'
    }

    $('body').addClass(className)
    ReactGA.pageview(pageViewName)
  }

  // <Route path="/login" component={Login} />
  render() {
    return (
      <div className="content">
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/futures" component={FuturesMain} />
          <Route
            exact
            path="/futures/pricingchart/:chart"
            component={PricingChart}
          />
          <Route path="/futures/:feed" component={FuturesFeed} />
          <Route
            path="/price/insurance/:insurance"
            component={PriceInsurance}
          />
          <Route
            exact
            path="/breakeven/backgrounder"
            component={BackgrounderList}
          />
          <Route
            exact
            path="/breakeven/backgrounder/calculator"
            component={BackgrounderCalculator}
          />
          <Route
            path="/breakeven/backgrounder/calculator/:id"
            component={BackgrounderCalculator}
          />
          <Route exact path="/breakeven/finishing" component={FinishingList} />
          <Route
            exact
            path="/breakeven/finishing/calculator"
            component={FinishingCalculator}
          />
          <Route
            path="/breakeven/finishing/calculator/:id"
            component={FinishingCalculator}
          />
          <Route
            exact
            path="/price/projections"
            component={PriceProjectionsList}
          />
          <Route
            exact
            path="/price/projections/calculator"
            component={PriceProjectionsCalculator}
          />
          <Route
            path="/price/projections/calculator/:id"
            component={PriceProjectionsCalculator}
          />
          <Route path="/contact" component={ContactUs} />
          <Route path="/account" component={Account} />
          <Route path="/register" component={Register} />
          <Route path="/resetDefaults" component={ResetDefaults} />
          <Route component={NotFound} />
        </Switch>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/main.js